export const ASSESSMENT_TYPE_LOOKUP = {
  "CL003.1": "Initial/Comprehensive Assessment",
  "CL003.2": "Comprehensive Assessment",
  "CL003.3": "Routine",
  "CL003.4": "Face to Face Visit",
  "CL003.5": "Continuous Care Visits",
  "CL003.6": "Emergent",
  "CL003.7": "In-Patient",
  "CL003.8": "Watch Care Visit",
  "CL003.9": "EMC",
  "CL003.10": "Phone Call",
  "CL003.11": "Supervisory Visit",
  "CL003.12": "Initial Nursing Assessment",
  "CL003.13": "Hospice House Comprehensive",
  "CL003.14": "Hospice House Encounter",
  "CL003.15": "New Patient/Admit",
  "CL003.16": "Established",
  "CL003.33": "Postmortem Encounter",
  "CL003.34": "External Face to Face Visit",
  "CL003.35": "LCD",
};

export const ROLE_LOOKUP = {
  "SD002.1": "Case Manager",
  "SD002.2": "Team Lead",
  "SD002.3": "Registered Nurse (RN)",
  "SD002.4": "Nurse Practitioner",
  "SD002.5": "Hospice Aide",
  "SD002.6": "Homemaker",
  "SD002.7": "Social Worker",
  "SD002.8": "Spiritual Advisor",
  "SD002.9": "Bereavement",
  "SD002.10": "Medical Director",
  "SD002.11": "LPN/LVN Nurse",
  "SD002.12": "Volunteer Coordinator",
  "SD002.13": "Volunteer",
  OTH: "Other",
};

export const ROLE_LOOKUP_EVENT_GRID = {
  "SD002.1": "Case Manager",
  "SD002.2": "Team Lead",
  "SD002.3": "Registered Nurse",
  "SD002.4": "Nurse Practitioner",
  "SD002.5": "Hospice Aide",
  "SD002.6": "Homemaker",
  "SD002.7": "Social Worker",
  "SD002.8": "Spiritual Advisor",
  "SD002.9": "Bereavement",
  "SD002.10": "Medical Director",
  "SD002.11": "Licensed Nurse (LPN/LVN)",
  "SD002.12": "Volunteer Coordinator",
  "SD002.13": "Volunteer",
  OTH: "Other",
};

export const ROLE_LOOKUP_ABBREVIATION = {
  CM: "SD002.1",
  TL: "SD002.2",
  RN: "SD002.3",
  NP: "SD002.4",
  HA: "SD002.5",
  HM: "SD002.6",
  SW: "SD002.7",
  SA: "SD002.8",
  BC: "SD002.9",
  MD: "SD002.10",
  LN: "SD002.11",
  VC: "SD002.12",
  VOL: "SD002.13",
};

// =============================================================================
// VISIT TYPE CONSTANTS
// =============================================================================
export const ALL_VISIT_TYPES = {
  LOOKUP_CODE: {
    HOSPICE: {
      INITIAL_NURSING_ASSESSMENT: "CL003.12",
      ROUTINE: "CL003.3",
      COMPREHENSIVE_ASSESSMENT: "CL003.2",
      CONTINUOUS_CARE_VISIT: "CL003.5",
      EMC: "CL003.9",
      EMERGENT: "CL003.6",
      FACE_TO_FACE_VISIT: "CL003.4",
      HOSPICE_HOUSE_COMPREHENSIVE: "CL003.13",
      HOSPICE_HOUSE_ENCOUNTER: "CL003.14",
      IN_PATIENT: "CL003.7",
      INITIAL_COMPREHENSIVE_ASSESSMENT: "CL003.1",
      PHONE_CALL: "CL003.10",
      SUPERVISORY_VISIT: "CL003.11",
      WATCH_CARE_VISIT: "CL003.8",
      HOSPICE_AIDE_ROUTINE_VISIT: "CL003.28",
      DEATH_VISIT: "CL003.33",
      LCD: "CL003.35",
    },
    PALLIATIVE: {
      NEW_PATIENT: {
        HOME_ASSISTED_LIVING: "CL003.29",
        NURSING_HOME_SKILLED_NURSING: "CL003.31",
      },
      ESTABLISHED_PATIENT: {
        HOME_ASSISTED_LIVING: "CL003.30",
        NURSING_HOME_SKILLED_NURSING: "CL003.32",
      },
      HOSPITAL: {
        FOLLOW_UP_VISIT: "CL003.18",
        INITIAL_VISIT: "CL003.20",
      },
    },
  },
  LOOKUP_VALUE: {
    HOSPICE: {
      INITIAL_NURSING_ASSESSMENT: "Initial Nursing Assessment",
      ROUTINE: "Routine",
      COMPREHENSIVE_ASSESSMENT: "Comprehensive Assessment",
      CONTINUOUS_CARE_VISIT: "Continuous Care Visits",
      EMC: "EMC",
      EMERGENT: "Emergent",
      FACE_TO_FACE_VISIT: "Face to Face Visit",
      HOSPICE_HOUSE_COMPREHENSIVE: "Hospice House Comprehensive",
      HOSPICE_HOUSE_ENCOUNTER: "Hospice House Encounter",
      IN_PATIENT: "In-Patient",
      INITIAL_COMPREHENSIVE_ASSESSMENT: "Initial/Comprehensive Assessment",
      PHONE_CALL: "Phone Call",
      SUPERVISORY_VISIT: "Supervisory Visit",
      WATCH_CARE_VISIT: "Watch Care Visit",
      HOSPICE_AIDE_ROUTINE_VISIT: "Hospice Aide Routine Visit",
      DEATH_VISIT: "Postmortem Encounter",
      EXTERNAL_FACE_TO_FACE: "External Face to Face Visit",
      LCD: "LCD",
    },
    PALLIATIVE: {
      NEW_PATIENT: {
        HOME_ASSISTED_LIVING: "New Patient - Home/Assisted Living",
        NURSING_HOME_SKILLED_NURSING:
          "New Patient - Nursing Home/Skilled Nursing",
      },
      ESTABLISHED_PATIENT: {
        HOME_ASSISTED_LIVING: "Established Patient - Home/Assisted Living",
        NURSING_HOME_SKILLED_NURSING:
          "Established Patient - Nursing Home/Skilled Nursing",
      },
      HOSPITAL: {
        FOLLOW_UP_VISIT: "Follow Up Visit - Hospital",
        INITIAL_VISIT: "Initial Visit - Hospital",
      },
    },
  },
  ASSESSMENT_TYPE: {
    HOSPICE: {
      INITIAL_NURSING_ASSESSMENT: {
        lookupCode: "CL003.12",
        lookupValue: "Initial Nursing Assessment",
      },
      ROUTINE: {
        lookupCode: "CL003.3",
        lookupValue: "Routine",
      },
      COMPREHENSIVE_ASSESSMENT: {
        lookupCode: "CL003.2",
        lookupValue: "Comprehensive Assessment",
      },
      CONTINUOUS_CARE_VISIT: {
        lookupCode: "CL003.5",
        lookupValue: "Continuous Care Visits",
      },
      EMC: {
        lookupCode: "CL003.9",
        lookupValue: "EMC",
      },
      EMERGENT: {
        lookupCode: "CL003.6",
        lookupValue: "Emergent",
      },
      FACE_TO_FACE_VISIT: {
        lookupCode: "CL003.4",
        lookupValue: "Face to Face Visit",
      },
      HOSPICE_HOUSE_COMPREHENSIVE: {
        lookupCode: "CL003.13",
        lookupValue: "Hospice House Comprehensive",
      },
      HOSPICE_HOUSE_ENCOUNTER: {
        lookupCode: "CL003.14",
        lookupValue: "Hospice House Encounter",
      },
      IN_PATIENT: {
        lookupCode: "CL003.7",
        lookupValue: "In-Patient",
      },
      INITIAL_COMPREHENSIVE_ASSESSMENT: {
        lookupCode: "CL003.1",
        lookupValue: "Initial/Comprehensive Assessment",
      },
      PHONE_CALL: {
        lookupCode: "CL003.10",
        lookupValue: "Phone Call",
      },
      SUPERVISORY_VISIT: {
        lookupCode: "CL003.11",
        lookupValue: "Supervisory Visit",
      },
      WATCH_CARE_VISIT: {
        lookupCode: "CL003.8",
        lookupValue: "Watch Care Visit",
      },
      HOSPICE_AIDE_ROUTINE_VISIT: {
        lookupCode: "CL003.28",
        lookupValue: "Hospice Aide Routine Visit",
      },
      DEATH_VISIT: {
        lookupCode: "CL003.33",
        lookupValue: "Postmortem Encounter",
      },
      EXTERNAL_FACE_TO_FACE: {
        lookupCode: "CL003.34",
        lookupValue: "External Face to Face Visit",
      },
      LCD: {
        lookupCode: "CL003.35",
        lookupValue: "LCD",
      },
    },
    PALLIATIVE: {
      NEW_PATIENT: {
        HOME_ASSISTED_LIVING: {
          lookupCode: "CL003.29",
          lookupValue: "New Patient - Home/Assisted Living",
        },
        NURSING_HOME_SKILLED_NURSING: {
          lookupCode: "CL003.31",
          lookupValue: "New Patient - Nursing Home/Skilled Nursing",
        },
      },
      ESTABLISHED_PATIENT: {
        HOME_ASSISTED_LIVING: {
          lookupCode: "CL003.30",
          lookupValue: "Established Patient - Home/Assisted Living",
        },
        NURSING_HOME_SKILLED_NURSING: {
          lookupCode: "CL003.32",
          lookupValue: "Established Patient - Nursing Home/Skilled Nursing",
        },
      },
      HOSPITAL: {
        FOLLOW_UP_VISIT: {
          lookupCode: "CL003.18",
          lookupValue: "Follow Up Visit - Hospital",
        },
        INITIAL_VISIT: {
          lookupCode: "CL003.20",
          lookupValue: "Initial Visit - Hospital",
        },
      },
    },
  },
} as const;

export const PALLIATIVE_VISIT_TYPES = [
  {
    lookupCode: "CL003.29",
    lookupValue: "New Patient - Home/Assisted Living",
  },
  {
    lookupCode: "CL003.30",
    lookupValue: "Established Patient - Home/Assisted Living",
  },
  {
    lookupCode: "CL003.31",
    lookupValue: "New Patient - Nursing Home/Skilled Nursing",
  },
  {
    lookupCode: "CL003.32",
    lookupValue: "Established Patient - Nursing Home/Skilled Nursing",
  },
  {
    lookupCode: "CL003.18",
    lookupValue: "Follow Up Visit - Hospital",
  },
  {
    lookupCode: "CL003.20",
    lookupValue: "Initial Visit - Hospital",
  },
] as const;

export const HOPE_VISIT_TYPES = {
  SYMPTOM_FOLLOW_UP: "SFV",
  HOPE_UPDATE_VISIT_1: "HUV 1",
  HOPE_UPDATE_VISIT_2: "HUV 2",
} as const;

export const HOSPICE_VISIT_TYPES = [
  {
    lookupCode: "CL003.12",
    lookupValue: "Initial Nursing Assessment",
  },
  {
    lookupCode: "CL003.3",
    lookupValue: "Routine",
  },
  {
    lookupCode: "CL003.2",
    lookupValue: "Comprehensive Assessment",
  },
  {
    lookupCode: "CL003.5",
    lookupValue: "Continuous Care Visits",
  },
  {
    lookupCode: "CL003.9",
    lookupValue: "EMC",
  },
  {
    lookupCode: "CL003.6",
    lookupValue: "Emergent",
  },
  {
    lookupCode: "CL003.4",
    lookupValue: "Face to Face Visit",
  },
  {
    lookupCode: "CL003.13",
    lookupValue: "Hospice House Comprehensive",
  },
  {
    lookupCode: "CL003.14",
    lookupValue: "Hospice House Encounter",
  },
  {
    lookupCode: "CL003.7",
    lookupValue: "In-Patient",
  },
  {
    lookupCode: "CL003.1",
    lookupValue: "Initial/Comprehensive Assessment",
  },
  {
    lookupCode: "CL003.10",
    lookupValue: "Phone Call",
  },
  {
    lookupCode: "CL003.11",
    lookupValue: "Supervisory Visit",
  },
  {
    lookupCode: "CL003.8",
    lookupValue: "Watch Care Visit",
  },
  {
    lookupCode: "CL003.28",
    lookupValue: "Hospice Aide Routine Visit",
  },
  {
    lookupCode: "CL003.33",
    lookupValue: "Postmortem Encounter",
  },
  {
    lookupCode: "CL003.34",
    lookupValue: "External Face to Face Visit",
  },
  {
    lookupCode: "CL003.35",
    lookupValue: "LCD",
  },
] as const;

// =============================================================================
// ROLE CONSTANTS
// =============================================================================
export const ALL_ROLES = {
  LOOKUP_CODE: {
    BEREAVEMENT_COUNSELOR: "SD002.9",
    CASE_MANAGER: "SD002.1",
    HOME_MAKER: "SD002.6",
    HOSPICE_AIDE: "SD002.5",
    MEDICAL_DIRECTOR: "SD002.10",
    NURSE_PRACTITIONER: "SD002.4",
    REGISTERED_NURSE_RN: "SD002.3",
    LICENSED_NURSE: "SD002.11",
    SOCIAL_WORKER: "SD002.7",
    SPIRITUAL_ADVISOR: "SD002.8",
    TEAM_LEAD: "SD002.2",
    VOLUNTEER: "SD002.13",
    VOLUNTEER_COORDINATOR: "SD002.12",
  },
  LOOKUP_VALUE: {
    BEREAVEMENT_COUNSELOR: "Bereavement Counselor",
    CASE_MANAGER: "Case Manager",
    HOME_MAKER: "Home Maker",
    HOSPICE_AIDE: "Hospice Aide",
    MEDICAL_DIRECTOR: "Medical Director",
    NURSE_PRACTITIONER: "Nurse Practitioner",
    REGISTERED_NURSE_RN: "Registered Nurse (RN)",
    LICENSED_NURSE: "Licensed Nurse",
    SOCIAL_WORKER: "Social Worker",
    SPIRITUAL_ADVISOR: "Spiritual Advisor",
    TEAM_LEAD: "Team Lead",
    VOLUNTEER: "Volunteer",
    VOLUNTEER_COORDINATOR: "Volunteer Coordinator",
  },
  ASSESSMENT_ROLE: {
    BEREAVEMENT_COUNSELOR: {
      lookupCode: "SD002.9",
      lookupValue: "Bereavement Counselor",
    },
    CASE_MANAGER: {
      lookupCode: "SD002.1",
      lookupValue: "Case Manager",
    },
    HOME_MAKER: {
      lookupCode: "SD002.6",
      lookupValue: "Home Maker",
    },
    HOSPICE_AIDE: {
      lookupCode: "SD002.5",
      lookupValue: "Hospice Aide",
    },
    MEDICAL_DIRECTOR: {
      lookupCode: "SD002.10",
      lookupValue: "Medical Director",
    },
    NURSE_PRACTITIONER: {
      lookupCode: "SD002.4",
      lookupValue: "Nurse Practitioner",
    },
    REGISTERED_NURSE_RN: {
      lookupCode: "SD002.3",
      lookupValue: "Registered Nurse (RN)",
    },
    LICENSED_NURSE: {
      lookupCode: "SD002.11",
      lookupValue: "Licensed Nurse",
    },
    SOCIAL_WORKER: {
      lookupCode: "SD002.7",
      lookupValue: "Social Worker",
    },
    SPIRITUAL_ADVISOR: {
      lookupCode: "SD002.8",
      lookupValue: "Spiritual Advisor",
    },
    TEAM_LEAD: {
      lookupCode: "SD002.2",
      lookupValue: "Team Lead",
    },
    VOLUNTEER: {
      lookupCode: "SD002.13",
      lookupValue: "Volunteer",
    },
    VOLUNTEER_COORDINATOR: {
      lookupCode: "SD002.12",
      lookupValue: "Volunteer Coordinator",
    },
  },
} as const;

export const DEFAULT_HOSPICE_ROLES = [
  {
    lookupCode: "SD002.9",
    lookupValue: "Bereavement Counselor",
  },
  {
    lookupCode: "SD002.1",
    lookupValue: "Case Manager",
  },
  {
    lookupCode: "SD002.6",
    lookupValue: "Home Maker",
  },
  {
    lookupCode: "SD002.5",
    lookupValue: "Hospice Aide",
  },
  {
    lookupCode: "SD002.10",
    lookupValue: "Medical Director",
  },
  {
    lookupCode: "SD002.4",
    lookupValue: "Nurse Practitioner",
  },
  {
    lookupCode: "SD002.3",
    lookupValue: "Registered Nurse (RN)",
  },
  {
    lookupCode: "SD002.11",
    lookupValue: "Licensed Nurse",
  },
  {
    lookupCode: "SD002.7",
    lookupValue: "Social Worker",
  },
  {
    lookupCode: "SD002.8",
    lookupValue: "Spiritual Advisor",
  },
  {
    lookupCode: "SD002.2",
    lookupValue: "Team Lead",
  },
  {
    lookupCode: "SD002.13",
    lookupValue: "Volunteer",
  },
  {
    lookupCode: "SD002.12",
    lookupValue: "Volunteer Coordinator",
  },
] as const;

export const DEFAULT_PALLIATIVE_ROLES = [
  {
    lookupCode: "SD002.10",
    lookupValue: "Medical Director",
  },
  {
    lookupCode: "SD002.4",
    lookupValue: "Nurse Practitioner",
  },
  {
    lookupCode: "SD002.3",
    lookupValue: "Registered Nurse (RN)",
  },
  {
    lookupCode: "SD002.11",
    lookupValue: "Licensed Nurse",
  },
  {
    lookupCode: "SD002.7",
    lookupValue: "Social Worker",
  },
  {
    lookupCode: "SD002.8",
    lookupValue: "Spiritual Advisor",
  },
  {
    lookupCode: "SD002.2",
    lookupValue: "Team Lead",
  },
] as const;

// =============================================================================
// MISCELLANEOUS DISCIPLINES CONSTANT
// =============================================================================
export const MISC_DISCIPLINES = {
  LOOKUP_VALUE: {
    HOSPICE_AID: "Hospice Aid",
    SKILLED_NURSE: "Skilled Nurse",
    SKILLED_NURSING: "Skilled Nursing",
    BEREAVEMENT: "Bereavement",
  },
  HOSPICE_AID: {
    lookupValue: "Hospice Aid",
  },
  SKILLED_NURSE: {
    lookupValue: "Skilled Nurse",
  },
  SKILLED_NURSING: {
    lookupValue: "Skilled Nursing",
  },
  BEREAVEMENT: {
    lookupValue: "Bereavement",
  },
} as const;

// =============================================================================
// LEVELS OF CARE CONSTANT
// =============================================================================
export const LEVELS_OF_CARE = {
  LOOKUP_CODE: {
    ROUTINE_HOME_CARE: "SD001.1",
    GENERAL_IN_PATIENT: "SD001.2",
    CONTINUOUS_CARE: "SD001.3",
    RESPITE_CARE: "SD001.4",
    PALLIATIVE_CARE: "SD001.5",
  },
  LOOKUP_VALUE: {
    ROUTINE_HOME_CARE: "Routine Home Care",
    GENERAL_IN_PATIENT: "General In-patient",
    CONTINUOUS_CARE: "Continuous Care",
    RESPITE_CARE: "Respite Care",
    PALLIATIVE_CARE: "Palliative Care",
  },
  ROUTINE_HOME_CARE: {
    lookupCode: "SD001.1",
    lookupValue: "Routine Home Care",
  },
  GENERAL_IN_PATIENT: {
    lookupCode: "SD001.2",
    lookupValue: "General In-patient",
  },
  CONTINUOUS_CARE: {
    lookupCode: "SD001.3",
    lookupValue: "Continuous Care",
  },
  RESPITE_CARE: {
    lookupCode: "SD001.4",
    lookupValue: "Respite Care",
  },
  PALLIATIVE_CARE: {
    lookupCode: "SD001.5",
    lookupValue: "Palliative Care",
  },
} as const;

// =============================================================================
// CARE LOCATIONS CONSTANT
// =============================================================================
export const CARE_LOCATIONS = {
  HOME: "Home",
  ASSISTED_LIVING_FACILITY: "Assisted Living Facility",
  NURSING_HOME: "Nursing Home",
  SKILLED_NURSING_FACILITY: "Skilled Nursing Facility",
  HOSPITAL: "Hospital",
} as const;



// WEBPACK FOOTER //
// ./src/configs/calendar-config.ts